import { application } from "../application"

import AlphabetNavController from "./alphabet_nav_controller"
import AvatarUploadController from "./avatar_upload_controller"
import BlogToolbarController from "./blog_toolbar_controller"
import CircleProgressController from "./circle_progress_controller"
import CompletionsController from "./completions_controller"
import ContentTooltipController from "./content_tooltip_controller"
import CourseFeedController from "./course_feed_controller"
import CoursePlayerController from "./course_player_controller"
import EditableFormController from "./editable_form_controller"
import FileUploadController from "./file_upload_controller"
import LiveStreamMessagesController from "./live_stream_messages_controller"
import LiveStreamPlayerController from "./live_stream_player_controller"
import LiveStreamQuestionsController from "./live_stream_questions_controller"
import MentionsController from "./mentions_controller"
import NotificationController from "./notification_controller"
import PasswordRevealController from "./password_reveal_controller"
import PollsController from "./polls_controller"
import ReadMoreToggleController from "./read_more_toggle_controller"
import ReadingProgressController from "./reading_progress_controller"
import ReplyController from "./reply_controller"
import ScrollToBottomController from "./scroll_to_bottom_controller"
import SlideoverMenuController from "./slideover_menu_controller"
import SlideOverCartController from "./slide_over_cart_controller"
import StripeCheckoutsController from "./stripe_checkouts_controller"
import TableOfContentsController from "./table_of_contents_controller"
import TestimonialsModalController from "./testimonials_modal_controller"
import VideoPlayerGenericController from "./video_player_generic_controller"
import VotesController from "./votes_controller"
import WorkshopSubscriptionFormController from "./workshop_subscription_form_controller"

application.register("frontend--alphabet-nav", AlphabetNavController)
application.register("frontend--avatar-upload", AvatarUploadController)
application.register("frontend--blog-toolbar", BlogToolbarController)
application.register("frontend--circle-progress", CircleProgressController)
application.register("frontend--completions", CompletionsController)
application.register("frontend--content-tooltip", ContentTooltipController)
application.register("frontend--course-feed", CourseFeedController)
application.register("frontend--course-player", CoursePlayerController)
application.register("frontend--editable-form", EditableFormController)
application.register("frontend--file-upload", FileUploadController)
application.register("frontend--live-stream-messages", LiveStreamMessagesController)
application.register("frontend--live-stream-player", LiveStreamPlayerController)
application.register("frontend--live-stream-questions", LiveStreamQuestionsController)
application.register("frontend--mentions", MentionsController)
application.register("frontend--notification", NotificationController)
application.register("frontend--password-reveal", PasswordRevealController)
application.register("frontend--polls", PollsController)
application.register("frontend--read-more-toggle", ReadMoreToggleController)
application.register("frontend--reading-progress", ReadingProgressController)
application.register("frontend--reply", ReplyController)
application.register("frontend--scroll-to-bottom", ScrollToBottomController)
application.register("frontend--slideover-menu", SlideoverMenuController)
application.register("frontend--slide-over-cart", SlideOverCartController)
application.register("frontend--stripe-checkouts", StripeCheckoutsController)
application.register("frontend--table-of-contents", TableOfContentsController)
application.register("frontend--testimonials-modal", TestimonialsModalController)
application.register("frontend--video-player-generic", VideoPlayerGenericController)
application.register("frontend--votes", VotesController)
application.register("frontend--workshop-subscription-form", WorkshopSubscriptionFormController)

